module.exports = __webpack_public_path__ + "img/diamond.6d268858.svg";